export default {
  setGeolocation(state, geolocationData) {
    state.currentGeolocation = geolocationData || {};
    localStorage.setItem("currentGeolocation", JSON.stringify(geolocationData || {}));
  },
};
